class FSPackSelector extends HTMLElement {
    constructor() {
        super();


        this.packCards = [...this.querySelectorAll('.pack_card')];
        this.selectedCard = this.querySelector('.pack_card.active');
        this.qtyField = document.querySelector("#fs_quantity_input");
    }

    connectedCallback() {
        // onload
        this.updateQty(Number(this.selectedCard.dataset.quantity));

        // onclick
        this.packCards.forEach(card => {
            card.addEventListener('click', () => this.handleClick(card));
        });
    }


    handleClick(card) {
        if (card.classList.contains('active'))return;
        this.packCards.forEach(card => {
            card.classList.remove('active');
        });
        card.classList.add('active');
        this.selectedCard = card;

        // update quantity
        this.updateQty(Number(card.dataset.quantity));
    }

    updateQty(qty){
        if(this.qtyField){
            this.qtyField.value = qty;
        }
    }
}

if (!customElements.get('fs-pack-selector')) {
    customElements.define('fs-pack-selector', FSPackSelector);
}
